import React from "react"
import {
  PRICE,
  SERVICE_CHARGE,
  SUBTOTAL,
  TAX,
  DISCOUNT,
} from "../../constants/messages"
import "./OrderDetails.scss"
import _ from "../../utils/lodashUtils"

const OrderDetails = props => {
  const {
    cart,
    subtotal,
    name,
    isOrderCombined,
    customOrderWrapperClass,
  } = props
  return (
    <div
      id="CheckoutContent"
      className={`order-item ${customOrderWrapperClass}`}
    >
      {cart &&
        cart.map(({ id, quantity, name, price, instructions, options }) => {
          return (
            <div className="item-container" key={id}>
              <div className="item-details">
                {quantity} {name}
                {options &&
                  options.map(option => {
                    return option.options.map(item => {
                      return <div className="instruction">{item.name}</div>
                    })
                  })}
                <div className="instruction">{instructions}</div>
              </div>
              <div className="price">{PRICE(parseFloat(price).toFixed(2))}</div>
            </div>
          )
        })}
      {isOrderCombined && (
        <div className="item-container grand-total">
          <span>{name} total</span>
          <span>${parseFloat(subtotal).toFixed(2)}</span>
        </div>
      )}
    </div>
  )
}

export const PriceBreakdown = props => {
  const {
    tax = 0,
    subtotal = 0,
    fees = 0,
    discount = 0,
    isOrderCombined = false,
    isPayingForBoth = false,
    name,
    total = 0,
    customOrderWrapperClass,
  } = props

  //display different components of total in Place order and checkout detail page
  return (
    <div className={`order-item ${customOrderWrapperClass}`}>
      {!isOrderCombined && !isPayingForBoth && (
        <div className="sub-total">
          <div>{SUBTOTAL}</div>
          <div>{PRICE(Number(subtotal).toFixed(2))}</div>
        </div>
      )}
      {!_.isEmpty(fees) &&
        fees.map((feeItem, index) => {
          if (+feeItem.value <= 0) {
            return null
          }
          return (
            <div key={index} className="discount">
              <span>{_.get(feeItem, "name", "")}</span>
              <span>${Number(_.get(feeItem, "value", 0)).toFixed(2)}</span>
            </div>
          )
        })}
      <div className="tax">
        <div>{TAX}</div>
        <div>{PRICE(tax.toFixed(2))}</div>
      </div>
      <div className="discount">
        <div>{DISCOUNT}</div>
        <div>{PRICE(Number(discount).toFixed(2))}</div>
      </div>
      {isPayingForBoth && (
        <div className="sub-total">
          <div>{name} total</div>
          <div>{PRICE(Number(total).toFixed(2))}</div>
        </div>
      )}
    </div>
  )
}
export default OrderDetails
